/* eslint-disable no-unused-vars */
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import React from 'react';
import Layout from '../Layout';
const LoginScreen = lazy(() => import('../Pages/Login'));
const SignupScreen = lazy(() => import('../Pages/Signup'));
const CreateAccountScreen = lazy(() => import('../Pages/CreateAccount'));
const Loading = lazy(() => import('../Components/Loading/index'));
const Dashboard = lazy(() => import('../Pages/Distruputer/DashBoard'));
const Displays = lazy(() => import('../Pages/Distruputer/Displays'));
const Locations = lazy(() => import('../Pages/Distruputer/Locations'));
const RateSchedules = lazy(() => import('../Pages/Distruputer/RateSchedules'));
const DsoUsers = lazy(() => import('../Pages/Distruputer/DsoUsers'));
const AdvertisersDSO = lazy(() => import('../Pages/Distruputer/Advertisers'));
const DisplayOwner = lazy(() => import('../Pages/Admin/DisplayOwner'));
const AdminAdvertiser = lazy(() => import('../Pages/Admin/Advertisers'));
const Campaigns = lazy(() => import('../Pages/Advertiser/Campaigns'));
const AdvertisersCampaigns = lazy(() =>
  import('../Pages/Distruputer/Advertisers/AdvertisersCampaigns/index')
);
const NotFound = lazy(() => import('../Pages/NotFound'));
const CampaignsDetailPage = lazy(() =>
  import('../Pages/Advertiser/Campaigns/CampaignsDetailPage')
);
const CreateNewCampaign = lazy(() =>
  import('../Pages/Advertiser/Campaigns/CreateNewCampaign')
);
const SettingsPage = lazy(() => import('../Pages/Shared/SettingsPage'));
const ProfileSettingsPage = lazy(() => import('../Pages/Shared/SettingsPage'));
const ChangePassword = lazy(() => import('../Pages/ChangePassword'));
const ResetPasswordCode = lazy(() => import('../Pages/ResetPasswordCode'));
const AdvertisersDisplay = lazy(() =>
  import('../Pages/Advertiser/AdvertisersDisplays')
);
const CreateNewDisplay = lazy(() =>
  import('../Pages/Distruputer/Displays/CreateNewDisplay')
);
const Layouts = lazy(() => import('../Pages/Distruputer/Layouts'));
const routes = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <Dashboard />,
      },
      {
        path: '/displays',
        element: <Displays />,
      },
      {
        path: '/advertiser',
        element: <AdvertisersDSO />,
      },
      {
        path: '/admin-advertisers',
        element: <AdminAdvertiser />,
      },
      {
        path: '/settings',
        element: <SettingsPage />,
      },
      {
        path: '/settings/:profile',
        element: <SettingsPage />,
      },
      {
        path: '/locations',
        element: <Locations />,
      },
      {
        path: '/rate-schedules',
        element: <RateSchedules />,
      },
      {
        path: '/Users',
        element: <DsoUsers />,
      },
      {
        path: '/create-new-display',
        element: <CreateNewDisplay />,
      },
      {
        path: '/campaigns',
        element: <Campaigns />,
      },
      {
        path: '/campaigns-approval',
        element: <AdvertisersCampaigns />,
      },
      {
        path: '/campaigns/:campaignId',
        element: <CampaignsDetailPage />,
      },
      {
        path: '/admin-display-owner',
        element: <DisplayOwner />,
      },
      {
        path: '/new-campaign',
        element: <CreateNewCampaign />,
      },
      {
        path: '/advertisers-displays',
        element: <AdvertisersDisplay />,
      },
      // {
      //   path: 'favourites',
      //   element: <Favourites />,
      // },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/login',
    element: <LoginScreen />,
  },
  {
    path: '/signup',
    element: <SignupScreen />,
  },
  {
    path: '/createAccount',
    element: <CreateAccountScreen />,
  },
  {
    path: '/loading',
    element: <Loading />,
  },
  {
    path: '/changePassword',
    element: <ChangePassword />,
  },
  {
    path: '/resetPasswordCode',
    element: <ResetPasswordCode />,
  },
]);
export default routes;
